import { formatInBrowserTZ } from './datetime';

// 格式化货币
const fmtCurrency = (v) => {
  const n = Number(v || 0);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(1)}k`;
  return `$${Math.round(n)}`;
};

// 截断地址
const trunc = (addr) => (addr && addr.length > 10 ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : (addr || '—'));

// 映射 API items -> UI 渲染结构
export function mapApiItems(items) {
  return items.map((it) => {
    const rt = it.recommended_traders || {};
    const detail = it.recommended_traders_detail || { yes: [], no: [] };
    const yesList = (detail.yes || [])
      .sort((a, b) => (b.value || 0) - (a.value || 0))
      .map((x) => ({ name: trunc(x.wallet), winRate: undefined, stake: fmtCurrency(x.value), note: '' }));
    const noList = (detail.no || [])
      .sort((a, b) => (b.value || 0) - (a.value || 0))
      .map((x) => ({ name: trunc(x.wallet), winRate: undefined, stake: fmtCurrency(x.value), note: '' }));

    // 市场概率：优先 outcome_prices
    let probYes = 50; let probNo = 50;
    let outcomes = Array.isArray(it.outcomes) ? it.outcomes : undefined;
    if (!outcomes && typeof it.outcomes === 'string') {
      try { const tmp = JSON.parse(it.outcomes); if (Array.isArray(tmp)) outcomes = tmp; } catch {}
    }
    const prices = Array.isArray(it.outcome_prices) ? it.outcome_prices : undefined;
    if (prices && prices.length >= 2) {
      let yesIdx = 0;
      if (outcomes && outcomes.length >= 2) {
        const idx = outcomes.findIndex((o) => String(o).toLowerCase() === 'yes');
        yesIdx = idx >= 0 ? idx : 0;
      }
      const yesP = prices[yesIdx];
      const p = typeof yesP === 'number' ? yesP : parseFloat(yesP);
      if (!Number.isNaN(p)) {
        const pct = p > 1 ? p : p * 100;
        probYes = Math.max(0, Math.min(100, Math.round(pct)));
        probNo = 100 - probYes;
      }
    } else {
      const yesV = Number(rt.yes_value || 0);
      const noV = Number(rt.no_value || 0);
      const totalV = yesV + noV;
      probYes = totalV > 0 ? Math.round((yesV / totalV) * 100) : 50;
      probNo = 100 - probYes;
    }

    return {
      id: it.slug,
      api_id: it.api_id || it.apiId,
      title: it.i18n?.zh_CN || it.question || it.slug,
      subtitle: '',
      category: (it.category_slugs && it.category_slugs[0]) || '综合',
      deadline: it.end_date ? formatInBrowserTZ(it.end_date) : '—',
      range: '',
      aiConfidence: 0,
      probYes,
      probNo,
      momentum: '',
      gradient: 'from-sky-500/40 via-indigo-500/25 to-violet-600/25',
      image: it.image || '',
      metrics: { volume: fmtCurrency(it.volume_24h || 0), smart: '', risk: '' },
      aiHighlights: [],
      aiNarrative: [],
      holders: { yes: yesList, no: noList },
      winners: [],
      losers: [],
      notifications: [],
      trade: { target: '', size: '', take: '' },
      holderInsights: [],
      watchers: 0,
      favorites: 0,
      smartStatus: '',
    };
  });
}

// 读取 Telegram Bot 用户名，用于深链跳转
const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME || 'gmgnaibot';

export function buildQuickTradeDeeplink(idOrSlug) {
  if (!idOrSlug) return null;
  // 统一格式：a_<action>_s_<idOrSlug>
  // 约定：若为纯数字，则视为 api_id；否则为 slug
  const params = `a_trade_s_${encodeURIComponent(idOrSlug)}`;
  return `https://t.me/${BOT_USERNAME}?start=${params}`;
}
